import messages from '@/store/module/messages';
import openApi from '@/store/module/openApi';

export default {
  messages,
  openApi,
};
